import { render, staticRenderFns } from "./OnlineInterview.vue?vue&type=template&id=070d975a&scoped=true&"
import script from "./OnlineInterview.vue?vue&type=script&lang=js&"
export * from "./OnlineInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d975a",
  null
  
)

export default component.exports